import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-collapse-item',
  templateUrl: './collapse-item.component.html'
})
export class CollapseItemComponent implements OnInit {

  @Input() columnItem
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor(public localDeviceDetector: LocalDeviceDetectorService) { }

  ngOnInit(): void {
  }

}
